'use strict';

/**
 * @author Maxim Seredkin
 */

export default ['$scope', '$routeParams', '$window', 'SupportTypeService',
                function($scope, $routeParams, $window,  SupportTypeService) {
                    $scope.types = [];
                    SupportTypeService.api.get({
                                           filters: [`'status' EQ 'ENABLED'`],
                                           sorts: ['name:ASC'],
                                       }, (data) => $scope.types = data._embedded);
                }];
